export default __webpack_public_path__ + "static/media/pause.d21967c4.svg";